import { Component } from '@angular/core';
import {interval, Subscription, take} from "rxjs";
import {Router} from "@angular/router";
import {ButtonComponent} from "../common/button/button.component";

@Component({
  selector: 'app-checkin-success',
  imports: [ButtonComponent],
  templateUrl: './checkin-success.component.html',
  styleUrl: './checkin-success.component.scss'
})
export class CheckinSuccessComponent {
  secondsLeft = 5;
  countdownSubscription?: Subscription;

  constructor(private router: Router) {}

  ngOnInit(): void {
    this.startCountdown();
  }

  ngOnDestroy(): void {
    this.countdownSubscription?.unsubscribe();
  }
  startCountdown(): void {
    this.countdownSubscription = interval(1000)
      .pipe(take(5))
      .subscribe({
        next: (count) => {
          this.secondsLeft = 5 - count - 1;
        },
        complete: () => {
          this.router.navigate(['']);
        }
      });
  }


  goBackToCheckin(): void {
    this.countdownSubscription?.unsubscribe();
    this.router.navigate(['']);
  }
}
